module.exports = __webpack_public_path__ + "static/media/dtj-sketch-3.4542c79c.jpg";